/**
 * Ownership gating for medication mutations (#2222).
 *
 * The API stamps every patient-medication record with the actor that created
 * it. Provider- and system-owned records are part of the prescribed care plan:
 * the patient UI must present them read-only (edit/stop/delete hidden with an
 * explanation) instead of letting the request fail at the server. The backend
 * remains the authoritative enforcement layer — this is presentation gating.
 *
 * Dose logging stays available regardless of ownership: a dose log is the
 * patient's own record about taking the medication, not a mutation of the
 * prescription itself.
 */
export function isProviderOwnedMedication(
  source: string | null | undefined,
): boolean {
  return source === "provider" || source === "system" || source === "doctor";
}
